import React from 'react';
import FormObjectRow from './FormObjectRow';
import { safeFormObjects } from '../../state/state';
import { formObjectSummaryKeys } from '../helper';

const FormObjectsTableRows = ({
  allowRemove,
  canEdit,
  code,
  deleteItem,
  field,
  items,
  onChange,
  showItem,
}) => (
  safeFormObjects(items, field).map((item, index) => {
    const key = formObjectSummaryKeys(field, item, `form_object_table_row_${code}_${index}_`);
    return (
      <FormObjectRow
        allowRemove={allowRemove}
        canEdit={canEdit}
        code={code}
        deleteItem={deleteItem ? () => deleteItem(index) : undefined}
        field={field}
        index={index}
        item={item}
        key={key}
        onChange={(fieldName, value) => onChange(index, fieldName, value)}
        showItem={showItem ? () => showItem(index) : undefined}
      />
    );
  })
);

export default FormObjectsTableRows;
